import Dashboard from './pages/dashboard';
import Header from './general/header';
import Footer from './general/footer';

export default function Home() {
    return (
        <div className="home-content">            
            <div id="page">
                <Header />
                <Dashboard />
                <Footer />
            </div>
        </div>
    );
}
